import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { booleanInstructions } from '../../tooltips/BooleanInstructions';

const BooleanInstructionsPage = () => {
    return (
        <div style={{ paddingTop: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
            <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        // Override default components to ensure proper rendering (AI vibe-coded, undiagnosed issue using default react-markdown)
                        ul: ({node, ...props}) => <ul style={{ listStyleType: 'disc', paddingLeft: '2rem' }} {...props} />,
                        ol: ({node, ...props}) => <ol style={{ listStyleType: 'decimal', paddingLeft: '2rem' }} {...props} />,
                        li: ({node, ...props}) => <li style={{ marginBottom: '0.5rem' }} {...props} />,
                        code: ({node, ...props}) => (
                            <code 
                                style={{ 
                                    backgroundColor: '#f1f1f1',
                                    padding: '0.2em 0.4em',
                                    borderRadius: '3px',
                                    fontFamily: 'monospace',
                                    fontSize: '0.9em',
                                    color: '#d63384'
                                }} 
                                {...props} 
                            />
                        ),
                        h1: ({node, children, ...props}) => <h1 style={{ fontSize: '2em', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }} {...props}>{children}</h1>,
                        h2: ({node, children, ...props}) => <h2 style={{ fontSize: '1.75em', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }} {...props}>{children}</h2>,
                        h3: ({node, children, ...props}) => <h3 style={{ fontSize: '1.5em', marginTop: '2rem', marginBottom: '1rem', fontWeight: 'bold' }} {...props}>{children}</h3>,
                        h4: ({node, children, ...props}) => <h4 style={{ fontSize: '1.1em', marginTop: '1.5rem', marginBottom: '0.75rem', fontWeight: 'bold' }} {...props}>{children}</h4>,
                        p: ({node, ...props}) => <p style={{ marginBottom: '1rem' }} {...props} />,
                    }}
                >
                    {booleanInstructions}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export default BooleanInstructionsPage;
